var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { AutoSearchConditionGroup } from 'src/app/shared/model/auto-search-condition-group.model';
import * as i0 from "@angular/core";
import * as i1 from "../http-header.service";
import * as i2 from "@angular/common/http";
var SearchAutoService = /** @class */ (function (_super) {
    __extends(SearchAutoService, _super);
    function SearchAutoService(header, http) {
        var _this = _super.call(this, header, http) || this;
        // サービス毎に初期値を設定する
        _this.initPage = { page: 1 };
        _this.initPerPage = { perPage: 50 };
        _this.selfServiceName = 'SearchAutoService';
        return _this;
    }
    SearchAutoService.prototype.doSearch = function (id, params) {
        return _super.prototype.requestPost.call(this, 'api/v1/matching_auto_with_filter', this.getSearchParameters(params));
    };
    SearchAutoService.prototype.setSearchCondition = function (searchCondition) {
        localStorage.setItem('searchCondition' + this.selfServiceName, JSON.stringify(searchCondition));
    };
    SearchAutoService.prototype.getAutoSearchConditionGroup = function () {
        return JSON.parse(localStorage.getItem('searchCondition' + this.selfServiceName));
    };
    SearchAutoService.prototype.getSearchParameters = function (sortParams) {
        var condition = this.getAutoSearchConditionGroup() || new AutoSearchConditionGroup({});
        var count = this.getSearchCount().getParams();
        var page = this.getSearchPage().getParams();
        var searchTags = { search_tag_ids: this.getSearchTagIds() };
        return Object.assign(condition, count, page, searchTags, sortParams);
    };
    SearchAutoService.ngInjectableDef = i0.defineInjectable({ factory: function SearchAutoService_Factory() { return new SearchAutoService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient)); }, token: SearchAutoService, providedIn: "root" });
    return SearchAutoService;
}(SearchService));
export { SearchAutoService };
